const VERSION = "8.1.1";
export {
  VERSION
};
